import React, { useState, useEffect } from "react";
import {
  CNavbar,
  CNavbarBrand,
  CContainer,
  CNavbarToggler,
  COffcanvas,
  COffcanvasHeader,
  COffcanvasTitle,
  CCloseButton,
  COffcanvasBody,
  CNavbarNav,
  CNavItem,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react-pro";
import { useTranslation } from "react-i18next";

import logo from "src/assets/icon/logo.png"

function NavbarFour() {
  const [visible, setVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const currentLang = i18n.language?.split("-")[0] || "pt";

  const langLabels = { pt: "PT", en: "EN", es: "ES" };

  return (
    <CNavbar
      className={`navLandingPageFour py-4 ${scrolled ? "scrolled" : ""}`}
      expand="xl"
      translate="no"
    >
      <a href="www.ghlogistica.com.br" className="back">{t("lp4_nav_back")} <div className="underline"></div></a>
      <div className="nav-container">
        <CContainer fluid>
          <CNavbarBrand className={`navLogo2`}>
            <a href="/">
              <img src={logo} alt="logo" width={200} />
            </a>
          </CNavbarBrand>
          <CNavbarToggler
            aria-controls="offcanvasNavbar2"
            aria-label="Toggle navigation"
            onClick={() => setVisible(!visible)}
          />
          <COffcanvas
            id="offcanvasNavbar2"
            placement="end"
            portal={false}
            visible={visible}
            onHide={() => setVisible(false)}
          >
            <COffcanvasHeader>
              <COffcanvasTitle></COffcanvasTitle>
              <CCloseButton
                className="text-reset"
                onClick={() => setVisible(false)}
              />
            </COffcanvasHeader>
            <COffcanvasBody>
              <div className="flex-content-nav">
                <CNavbarNav>
                  <CNavItem className={`px-1 homeLink`}>
                    <a href="#home" active reloadDocument>
                      {t("lp4_nav_home")}
                    </a>
                  </CNavItem>
                  <CNavItem className={`px-1 servicesLink`}>
                    <a href="#services" active reloadDocument>
                      {t("lp4_nav_services")}
                    </a>
                  </CNavItem>
                  <CNavItem className={`px-1 mapLink`}>
                    <a href="#map" active reloadDocument>
                      {t("lp4_nav_map")}
                    </a>
                  </CNavItem>
                </CNavbarNav>
                <CNavbarBrand className={`navLogo`}>
                  <img src={logo} alt="logo" width={230} />
                </CNavbarBrand>
                <CNavbarNav>
                  <CNavItem className={`px-1 operationsLink`}>
                    <a href="#operations" active reloadDocument>
                      {t("lp4_nav_operations")}
                    </a>
                  </CNavItem>
                  <CNavItem className={`px-1 licensesLink`}>
                    <a href="#licenses" active reloadDocument>
                      {t("lp4_nav_certifications")}
                    </a>
                  </CNavItem>
                  <CDropdown variant="btn-group" className="langLink">
                    <CDropdownToggle className="langToggle">
                      {langLabels[currentLang] || "PT"}
                    </CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem onClick={() => changeLanguage("pt")} className={currentLang === "pt" ? "lang-active" : ""}>
                        Português
                      </CDropdownItem>
                      <CDropdownItem onClick={() => changeLanguage("en")} className={currentLang === "en" ? "lang-active" : ""}>
                        English
                      </CDropdownItem>
                      <CDropdownItem onClick={() => changeLanguage("es")} className={currentLang === "es" ? "lang-active" : ""}>
                        Español
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                </CNavbarNav>
              </div>
            </COffcanvasBody>
          </COffcanvas>
        </CContainer>
      </div>
    </CNavbar>
  );
}

export default NavbarFour;
